export const API_URI = process.env.REACT_APP_API_URI || process.env.NEXT_PUBLIC_API_URI;
export const NETWORK_CHAIN_IDS = process.env.REACT_APP_NETWORK_CHAIN_IDS;
